<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
          <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SB"></ad-campaign-select>
        <gj-select
            v-model="status"
            :options="AdNegKeywordEnum.SB.statusOption"
            placeholder="状态"
        ></gj-select>
        <gj-select
            v-model="matchType"
            :options="AdNegKeywordEnum.SB.matchTypeOption"
            placeholder="匹配类型"
        ></gj-select>
        <gj-select-input
            v-model="keyword"
            :options="[
              {id: 0, text: '模糊查询'},
              {id: 1, text: '精准查询'},
            ]"
        ></gj-select-input>
        <template v-if="!$permission(['adsSbCampaigns:update', 'adsSbCampaigns:delete'])" #right>
          <gj-tool-group
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :helpName="helpName"
          ></gj-tool-group>
          <!-- :download="$permission('product:export')" download-url="广告导出地址" :download-params="globalParams" -->
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission(['adsSbCampaigns:update', 'adsSbCampaigns:delete'])" #operate-group>
      <gj-button type="primary" @click="addNegKeyword" :disabled="adStore.SB && adStore.SB.campaign && adStore.SB.campaign.updateFlag === 0">新增否定关键词</gj-button>
      <gj-button :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIn('state', [AdNegKeywordEnum.SB.status.ENABLE, AdNegKeywordEnum.SB.status.PAUSE])" @click="archive">归档</gj-button>
    </template>
    <template v-if="$permission(['adsSbCampaigns:update', 'adsSbCampaigns:delete'])" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
      ></gj-tool-group>
      <!-- :download="$permission('product:export')" download-url="广告导出地址" :download-params="globalParams" -->
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission(['adsSbCampaigns:update', 'adsSbCampaigns:delete'])"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :pagination="pagination"
          :selectable="notEqSelectable('state', AdNegKeywordEnum.SB.status.ARCHIVE)"
          :default-sort = "{prop: 'impressions', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:negKeywordName="{row}">
          {{row.keywordText | defaultShow}}
        </template>
        <template v-slot:belongGroup="{row}">
          <gj-tooltip
              :text-line="2"
              :content="row.groupName">
            {{row.groupName | defaultShow}}
          </gj-tooltip>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sb-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sb-ad-route-link>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {LOG_OP_TYPE} from "../../../common/options";
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin,
    currencySymbolMixin,
    inCampaignMixin,
    inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {queryMixin, selectionMixin} from "../../../../../../minxins";
  import {AdNegKeywordEnum} from "../../../common/enum";
  import AppArchiveWarningModal from "../../../common/modal/update-status/archive-warning-modal";
  import AppSbAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import {isMeaningful, isMeaningless, defaultVal} from "../../../../../../utils/common";
  import {adStore} from "../../../common/store";
  import {getSbAdNegKeywordPage, updateSbAdNegKeyword} from "../../../../../../api/ad";
  import AppAdLogModal from "../../../common/modal/log/ad-log-modal";
  import AppAddSpAdNegKeyword from "../../common/modal/add/neg-keyword/add-ad-neg-keyword";

  export default {
    name: "app-sb-ad-neg-keyword",
    components: {AppSbAdRouteLink, AdCampaignSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin,
      inCampaignMixin, inGroupMixin, tableNameMixin,
      selectionMixin, adBaseDataMixin, initDateMixin,
      queryMixin, currencySymbolMixin,
    ],
    inject: ['getBrandAdvertisingCornerMark'],
    created() {
      this.columns = [
        // adFields.status,
        adFields.negKeywordName,
        {...adFields.status, header: '状态', field: 'option:state', options: AdNegKeywordEnum.SB.statusOption},
        {...adFields.matchType, options: AdNegKeywordEnum.SB.matchTypeOption},
        // this.inCampaign ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        // {...adFields.startDate, help: null}
        adFields.op
      ].filter(e => e !== null);
    },
    data() {
      return {
        helpName:'sbadmanager',
        campaignIds: [],
        adStore,
        tableData: [],
        columns: [],
        AdNegKeywordEnum: AdNegKeywordEnum,
        // filter
        status: AdNegKeywordEnum.SB.status.ENABLE,
        matchType: null,
        keyword: {
          key: 0,
          value: null
        }
      }
    },
    methods: {
      // 新增否定关键词
      addNegKeyword() {
        this.$gjCreate(AppAddSpAdNegKeyword, {
          props: {
            marketId: this.marketId,
            dimension: this.dimension,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupChange(groupId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          status: AdNegKeywordEnum.SB.status.ENABLE,
          matchType: null,
          keyword: {
            key: 0,
            value: null
          }
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        this.getBrandAdvertisingCornerMark()
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            campaignId: this.campaignId,
            campaignIds: this.campaignIds,
            groupId: this.groupId,
            state: defaultVal(this.status, null),
            matchType: defaultVal(this.matchType, null),
            searchType: defaultVal(this.keyword.key, null),
            keywordText: this.keyword.value,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getSbAdNegKeywordPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records, adStore.SB.currencySymbol) || [];
              this.pagination = this.getPagination(data);
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              const params = {
                marketId: this.marketId,
                keywords: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  keywordId: e.keywordId,
                  state: AdNegKeywordEnum.SB.status.ARCHIVE
                }))
              };
              updateSbAdNegKeyword(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            campaignId: this.campaignId,
            groupId: this.groupId,
            name: isMeaningful(row) ? row.keywordText : '',
            opId: isMeaningful(row) ? row.keywordId : null,
            operatingObjectTypeProps: 5,
            adType: LOG_OP_TYPE.SB,
            object: LOG_OP_TYPE.SB.NEG_KEYWORD
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
